import { render, staticRenderFns } from "./AdminHeaderActions.vue?vue&type=template&id=c2a2043c"
import script from "./AdminHeaderActions.vue?vue&type=script&lang=js"
export * from "./AdminHeaderActions.vue?vue&type=script&lang=js"
import style0 from "./AdminHeaderActions.vue?vue&type=style&index=0&id=c2a2043c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports